
import { useState, useEffect } from "react";
import Sidebar from "../../components/sidebar";
import { getStoredUserData, getUserSession, isAdmin } from "../../utils/utils";
import NotificationView from "../../components/notification_view";
import { useNavigate } from "react-router-dom";
import { ApiClient } from "../../utils/apiclient";
import SearchBox from "../../components/search_box";
import VehiclesTable from "./vehicles_table";
import { Vehicle } from "../../utils/types";
import TopStrip from "../../components/top_strip";

const Vehicles = (_props: any) => {
  const navigate = useNavigate();
  const notifications = []
  const userData = getStoredUserData();
  const userSession = getUserSession();
  const apiClient = new ApiClient(userSession?.accessToken);
  const [vehicles, setVehicles] = useState([])
  const [filterdVehicles, setFilteredVehicles] = useState(vehicles)

  const showNotifications = () => {
    navigate(`/notifications/${userData?.id}`)
  }
  const handleClickNew = () => {
    navigate('/vehicles/new')
  }

  const getVehicles = async () => {
    const response = await apiClient.getVehicles();
      setVehicles(response.vehicles)
      setFilteredVehicles(response.vehicles)

  }

  useEffect(() => {
    getVehicles()
  }, [])
  return (<>
    <div className="w-full flex justify-end items-center bg-gray-100 pe-4">
      <TopStrip user={userData} />
    </div>
    <main className="w-full flex bg-white min-h-full">

      <div className="md:w-2/12 flex flex-col items-start text-center justify-center">
        <Sidebar notificationCount={notifications.length} user={userData} active={3} />                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 f
      </div>

      <div className="md:w-9/12 mx-auto space-y-4 mt-2">

         {isAdmin(userData) ? <div className="flex space-x-2 w-full my-2 pb-2 items-center justify-between border-b-2">
          <div className="w-full flex items-center justify-start space-x-2">
           <button className="bg-primaryLight text-textDefault hover:bg-accentDark hover:text-white px-2 py-2 w-2/12" onClick={handleClickNew}>New Vehicle</button>

          </div>
        </div>:null}
        <div className="w-full text-textDefault mt-2">
          <div className="w-full flex items-center justify-between py-4">
            <p className="text-2xl font-bold">Vehicles</p>
            {/* <input type="text" onChange={handleFilter} /> */}
            </div>

          <VehiclesTable vehicles={filterdVehicles} />
        </div>
      </div>
    </main></>
  );
}

export default Vehicles;